import URL from '@/creditflowresearch/Router/urlConstants';
import { toSlug } from '@framework/url/helpers/toSlug';
import { formatDealName } from '@/creditflowresearch/application/Deal/helpers';
import Region from '@/creditflowresearch/domain/Region';
import { AbsProduct, HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';
import ICompany from '@/creditflowresearch/domain/vo/ICompany';
import IDeal from '@/creditflowresearch/domain/vo/IDeal';
import { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';

export const getDealRoute = (deal: Partial<IDeal | ICorporateDeal>): string => {
  const { viewId } = deal;
  return `${ URL.DEAL }-${ viewId.toString() }-${ toSlug(formatDealName(deal)) }`;
};

export const getParentRoute = (
    { viewId, name },
): string => `${ URL.SPONSOR }-${ viewId }-${ toSlug(name) }`;

export const getIssuerRoute = (
    { viewId, name },
): string => `${ URL.ISSUER }-${ viewId }-${ toSlug(name) }`;

export const getCatalogRoute = (
  url: string,
  company: ICompany,
) => `${ url }-${ company.viewId }-${ toSlug(company.name) }?products=${
    [
      AbsProduct.ABBREVIATION,
      HycProduct.ABBREVIATION,
      IgcProduct.ABBREVIATION,
    ].join(',')
  }&regions=${
    [
      Region.APAC_ABBREVIATION,
      Region.EMEA_ABBREVIATION,
      Region.LATM_ABBREVIATION,
      Region.USOA_ABBREVIATION,
    ].join(',')
  }`;

export const getIndustryRoute = (industry: string, subindustry: string = '') => {
  let convertedIndustry = toSlug(decodeURI(industry));
  if (subindustry) {
    convertedIndustry += `-${ toSlug(decodeURI(subindustry)) }`;
  }
  return `/${ convertedIndustry }-${ URL.INDUSTRY_SUFFIX }`;
};

export const getSectorRoute = (sector: string, subsector: string = '') => {
  let convertedSector = toSlug(decodeURI(sector));
  if (subsector) {
    convertedSector += `-${ toSlug(decodeURI(subsector)) }`;
  }
  return `/${ convertedSector }-${ URL.SECTOR_SUFFIX }`;
};
